module.exports = __webpack_public_path__ + "static/media/ProjectEdit.f43022cb.png";